// ---
// Selectors.
// ---
export const byHtmlMeta = ({ htmlMeta }: any) => htmlMeta;

// ------------------------------------
// Action constants
// ------------------------------------
export const actionTypes = {
  HTML_META_GENERATED: 'HTML_META_GENERATED',
};

// ------------------------------------
// Action creators
// ------------------------------------
export const htmlMetaGenerated = (htmlMeta: any) => ({
  type: actionTypes.HTML_META_GENERATED,
  htmlMeta,
});

// ------------------------------------
// Reducer
// ------------------------------------
const INITIAL_STATE = {};

export const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case actionTypes.HTML_META_GENERATED:
      return {
        ...action.htmlMeta,
      };
    default:
      return state;
  }
};
